<div class="wrapper-content">
  @if (view() === 'loading') {
    <div class="loading-container">
      <oph-loading></oph-loading>
    </div>
  } @else if (view() === 'edit') {
    <project-edit (exitEdit)="showEditView.set(false)" />
  } @else {
    <projects-header
      [project]="project()"
      [isEditView]="view() === 'edit'"
      (projectSelected)="onProjectSelected($event)"
      (editClick)="onEditClick()"
      (exitEdit)="showEditView.set(false)"
    ></projects-header>
    @if (view() === 'challenge') {
      <projects-challenge />
    } @else {
      <project-view [project]="project()" (projectSelected)="onProjectSelected($event)" />
    }
  }
</div>
